import PropTypes from 'prop-types';
import QubFile from './File';

class QubFileBundle {
    constructor({ id, files = [], values }) {
        this.id = id;
        this.files = []; // files.map((file) => new QubFile(file)) ?? [];
        this.values = values;
    }

    async initializeFiles(files) {
        this.files = await Promise.all(files.map(async (file) => QubFile.create(file)));
    }

    setValue(name, value) {
        if (this.values) {
            this.values[name] = value;
        }
    }

    addFile(file) {
        // this.files.unshift(file);
        this.files.push(file);
    }

    removeFile(id) {
        this.files = this.files.filter((file) => file.id !== id);
    }

    getFile(id) {
        return this.files.find((file) => file.id === id);
    }

    static async create(params) {
        const instance = new QubFileBundle(params);
        await instance.initializeFiles(params.files ?? []);
        return instance;
    }
}

QubFileBundle.propTypes = {
    id: PropTypes.number,
    files: PropTypes.arrayOf(PropTypes.instanceOf(QubFile)),
    values: PropTypes.object
};

export default QubFileBundle;
